import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    badgeText: 'Offer extended until 10/03/2024',
    countDown: 'Only {days} days left to enjoy it!',
    description:
      'Refer up to 2 contacts and get €{amount} per referral for you, 2 months free for them.',
    howItWorks: 'How does it work?',
    title: 'Earn up to €{amount} by referring your contacts',
    yourReferrals: 'Your referrals',
  },
  fr: {
    badgeText: 'Offre prolongée jusqu’au 10/03/2024',
    countDown: 'Plus que {days} jours pour en profiter !',
    description:
      "Parrainez jusqu'à 2 contacts et obtenez {amount} € par parrainage pour vous, 2 mois offerts pour vos invité·es.",
    howItWorks: 'Comment ça marche ?',
    title: 'Obtenez jusqu’à {amount} € en parrainant vos contacts',
    yourReferrals: 'Vos parrainages',
  },
} as const);

export default locales;
